import { Table, columnsToCamelCase, cellNames } from '@/main/utils/table';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { UPDATE_BASIC_TABLE_SCHEMA } from '@/main/store/listEditTypes';
import { EditStoreBase } from '@/main/store/@types/edit.d';
import { SchemaMutationInput } from '@/main/store/@types/store.d';
import { Status } from '@/main/store/@types/page';
import _ from 'lodash';

import { apiProvider } from '../api';
import { SNIMANIE_CASU as name, CRUMB_LABEL_KEY, depTableNames, TIME_TABLE } from '../constants';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	edit: {
		Barcode: null as string | null,
		Rucne: false,
		CaswId: null as number | null,
		CaswText: null as string | null,
		CaswOzn: null as string | null,
		CaswPznText: null as string | null,
		PracovnikId: null as number | null,
		OsobniCislo: null as string | null,
		Jmeno: null as string | null,
		ZakazkaId: null as number | null,
		ZakazkaNrText: null as string | null,
		ZakazkaNr: null as number | null,
		ZacatekDat: null as Date | null,
		KonecDat: new Date('1899-12-31'),
	},
	depTableNames,
	depTableSettings: {
		[TIME_TABLE]: {
			filter(state) {
				return { PracovnikId: state.edit.PracovnikId };
			},
		},
	},
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {	},
	props: {
		mode: null,
	},
});
